import { Row, Button } from 'antd';
import _ from 'lodash';
import React from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';

import { CurrentUserStore } from 'stores';

function ButtonsContainer({ addSubItem }) {
  const currentUserSettings = CurrentUserStore.user.settings;

  return (
    <Row>
      <Button
        type="link"
        onClick={() =>
          addSubItem('labours', {
            key: _.random(100000),
            vendor: '',
            description: '',
            hours: 0,
            cost: currentUserSettings?.laborRate || 0,
            amount: 0,
          })
        }
        icon={<PlusCircleOutlined />}
        data-testid="add-labor-button"
      >
        Add Labor
      </Button>
      <Button
        type="link"
        icon={<PlusCircleOutlined />}
        onClick={() =>
          addSubItem('parts', {
            key: _.random(100000),
            id_vehicle_part: '',
            amount: 1,
            originalAmount: 1,
            markup: 0,
            cost: 0,
          })
        }
        data-testid="add-part-button"
      >
        Add Part
      </Button>
      <Button
        type="link"
        icon={<PlusCircleOutlined />}
        onClick={() =>
          addSubItem('miscellaneous', {
            key: _.random(100000),
            description: '',
            quantity: 1,
            unit_cost: 0,
          })
        }
        data-testid="add-misc-button"
      >
        Add Misc
      </Button>
      <Button
        type="link"
        icon={<PlusCircleOutlined />}
        onClick={() => {
          const issueKey = _.random(100000);
          addSubItem('services', {
            key: issueKey,
            id: null,
            id_vehicle_service: '',
            name: `Issue ${issueKey}`,
          });
        }}
      >
        Link Issues
      </Button>
      <Button
        type="link"
        icon={<PlusCircleOutlined />}
        onClick={() => {
          const defectKey = _.random(100000);
          addSubItem('defects', {
            key: defectKey,
            id_defect: null,
            name: `Defect ${defectKey}`,
            isResolved: false,
            comment: '',
            dvirId: null,
          });
        }}
      >
        Link DVIR Defects
      </Button>
      <Button
        type="link"
        icon={<PlusCircleOutlined />}
        onClick={() => {
          const pmKey = _.random(100000);
          addSubItem('pms', {
            key: pmKey,
            pms: [],
          });
        }}
      >
        Link Services
      </Button>
    </Row>
  );
}

export default ButtonsContainer;
